export default function Dashboard() {
    return (
        <>
            <h1 className="text-lg text-center">Dashboard Home</h1>
        </>
    )
}